import { MoreVertical, Settings } from 'lucide-react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import {
  SidebarShellMenuItems,
  useShellMenuHold,
} from '@/components/layout/left-sidebar.panel-menu'
import { QUIET_OVERFLOW_MENU_CONTENT_COMPACT_CLASS } from '@/lib/menu-chrome'
import { openWorkspaceExtensionSettings } from '@/lib/open-settings'
import { testIds } from '@/lib/test-ids'
import { cn } from '@/lib/utils'

/** Limb menu for the Nextcloud panel. Density belongs to Browse, not this tree. */
export function NextcloudOptionsMenu({
  organizationId,
  openTabsVisible,
  onOpenTabsVisibleChange,
  collapsed,
  onCollapseSidebar,
}: {
  organizationId?: string
  openTabsVisible: boolean
  onOpenTabsVisibleChange: (visible: boolean) => void
  collapsed: boolean
  onCollapseSidebar: () => void
}) {
  const onMenuOpenChange = useShellMenuHold()
  return (
    <DropdownMenu onOpenChange={onMenuOpenChange}>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className={cn(
            'flex h-6 shrink-0 items-center gap-1 rounded px-1',
            'text-sidebar-foreground/60 hover:bg-sidebar-accent/60 hover:text-sidebar-foreground',
          )}
          title="Nextcloud options"
          aria-label="Nextcloud options"
          data-testid={testIds.nextcloud.optionsMenu}
        >
          <MoreVertical className="h-3.5 w-3.5" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className={QUIET_OVERFLOW_MENU_CONTENT_COMPACT_CLASS}>
        <DropdownMenuItem
          onSelect={() => openWorkspaceExtensionSettings('nextcloud', organizationId)}
          data-testid={testIds.nextcloud.settingsMenuItem}
        >
          <Settings className="mr-2 h-4 w-4" />
          Settings
        </DropdownMenuItem>
        <SidebarShellMenuItems
          openTabsVisible={openTabsVisible}
          onOpenTabsVisibleChange={onOpenTabsVisibleChange}
          collapsed={collapsed}
          onCollapseSidebar={onCollapseSidebar}
        />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
